import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import chat from './modules/chat'; // 导入新模块 

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    chat // 注册新模块 
  },
  state: {  
    jobMessages: [], // 初始化为空数组
    auditRefreshFlag: 0  // 添加审核刷新标识
  },  
  mutations: {  
    SET_JOB_MESSAGES(state, messages) {  
      state.jobMessages = messages;  
    },
    // 添加触发刷新的 mutation
    TRIGGER_AUDIT_REFRESH(state) {
      state.auditRefreshFlag++
    }
  },
  // 添加 actions
  actions: {
    // 审核成功后调用这个 action
    refreshAuditData({ commit }) {
      commit('TRIGGER_AUDIT_REFRESH')
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js